<app-header></app-header>
<div class="container-fluid">
  <h2>FAANG Analyses</h2>
  <hr>

  <div fxLayoutGap="2%" fxLayout="row" fxLayout.lt-md="column">
    <div fxFlex="17">
      <app-filter title="Standard" [filterSize]=6></app-filter>
      <app-filter title="Species" [filterSize]=6></app-filter>
      <app-filter title="Assay type" [filterSize]=3></app-filter>
      <app-filter title="Dataset" [filterSize]=6></app-filter>
      <app-filter title="Analysis type" [filterSize]=3></app-filter>
      <app-filter title="Project" [filterSize]=4></app-filter>
    </div>

    <div fxFlex="83" class="table-responsive">
      @if (hasActiveFilters()) {
        <div>
          @defer (when hasActiveFilters()) {
            <app-active-filter></app-active-filter>
          }
          @loading {
            Loading active filters...
          } @error {
            Failed to load active filters!
          }
          <button mat-raised-button (click)="removeFilter()">Remove all filters</button>
          <hr>
        </div>
      }
      <button mat-raised-button style="background-color: green; color: white;" (click)="onDownloadData()" [disabled]="downloading">
        Download data
      </button>
      @if (downloadData) {
        <button (click)="downloadFile('csv')" mat-raised-button>
          Export as CSV file
        </button>
      }
      @if (downloadData) {
        <button (click)="downloadFile('txt')" mat-raised-button>
          Export as Tabular file
        </button>
      }

      @if (downloading) {
        <div style="padding: 15px">
          <mat-spinner [diameter]="30"></mat-spinner>
        </div>
      }

      <app-table-server-side  [display_fields]="displayFields"
                              [column_names]="columnNames"
                              [indexDetails]="indexDetails"
                              [templates]="templates"
                              [filter_values]="filter_field"
                              [apiFunction]="loadTableDataFunction"
                              [query]="query"
                              [defaultSort]="defaultSort">
      </app-table-server-side>
    </div>
  </div>
</div>

<ng-template #accessionTemplate let-item>
  <a style="cursor: pointer" target="_blank" [routerLink]="item['accession']">{{item['accession']}}</a>
</ng-template>

<ng-template #assayTypeTemplate let-item>
  @if (item['assayType']) {
    <span>{{item['assayType']}}</span>
  }
  @if (!item['assayType']) {
    <span>Not Specified</span>
  }
</ng-template>
